import React, { useEffect, useState } from 'react';
import styles from './CookieBar.module.css';

const COOKIE_KEY = 'traily_cookie_accepted';

const CookieBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) setShow(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem(COOKIE_KEY, 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.cookieBar}>
        <div className={styles.text}>
          <span>
            Cookies: a Traily usa cookies para personalizar anúncios e melhorar a sua experiência no site.
            <br />
            Ao continuar navegando, você concorda com a nossa&nbsp;
            <a href="/termos" target="_blank" rel="noopener noreferrer">Termos e condições de uso</a>
            &nbsp;e&nbsp;
            <a href="/privacidade" target="_blank" rel="noopener noreferrer">Políticas de privacidade</a>.
          </span>
        </div>
        <button className={styles.acceptButton} onClick={acceptCookies}>
          Continuar e fechar
        </button>
      </div>
    </div>
  );
};

export default CookieBar;
